import Flex from "common/Boxes/Flex.tsx";
import Text from "common/Typography/Text.tsx";
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import VerticalDivider from "common/misc/VerticalDivider.tsx";
import Link from "common/Typography/Link.tsx";
import ExpandCollapse from "common/Animations/ExpandCollapse.tsx";
import React, { useContext } from "react";
import styled, { useTheme } from "styled-components";
import { MultiSymbolMarginContext } from "@shared/features/bots/BotForm/MultiSymbolMarginSelector/MultiSymbolMargin.context.ts";
import useSelectAll from "@shared/features/bots/BotForm/MultiSymbolMarginSelector/useSelectAll.ts";
import MarginSelectors from "features/bots/BotForm/MultiSymbolMargin/MarginSelectors.tsx";
import useMedia from "utils/hooks/useMedia.ts";
import MinusOutlined from "@ant-design/icons/MinusOutlined";
import PlusOutlined from "@ant-design/icons/PlusOutlined";

const SelectAll = () => {
  const theme = useTheme();
  const { globalSettingsExpanded, setGlobalSettingsExpanded } = useContext(
    MultiSymbolMarginContext
  )!;
  const {
    selectAllData,
    restoreToGlobalData,
    showNumSelectedText,
    hideSelectAll,
    isExpanded,
  } = useSelectAll();
  const overflowRestore = useMedia([`(max-width: 430px)`], [true], false);

  const restoreToGlobalButton = (
    <Link onClick={restoreToGlobalData.onClick}>
      {restoreToGlobalData.text}
    </Link>
  );

  const getSelectAllRow = () => {
    if (hideSelectAll) {
      return;
    }
    return (
      <Flex style={{ height: 32 }}>
        <Flex>
          {showNumSelectedText && (
            <>
              <Text>
                {selectAllData.numSelected} Selected{" "}
                <CloseOutlined
                  onClick={() => selectAllData.unselectAll()}
                  style={{ color: theme.colors.secondaryGrey }}
                />
              </Text>
              <VerticalDivider style={{ height: 20 }} $isSmallMobile={true} />
            </>
          )}
          {selectAllData.shouldDisplay && (
            <>
              <Link onClick={selectAllData.onClick}>{selectAllData.text}</Link>
              {restoreToGlobalData.shouldDisplay && !overflowRestore && (
                <>
                  <VerticalDivider
                    style={{ height: 20 }}
                    $isSmallMobile={true}
                  />
                  {restoreToGlobalButton}
                </>
              )}
            </>
          )}
        </Flex>
        {showNumSelectedText && (
          <IconsWrapper
            onClick={() => setGlobalSettingsExpanded(!globalSettingsExpanded)}
          >
            {!globalSettingsExpanded ? <MinusOutlined /> : <PlusOutlined />}
          </IconsWrapper>
        )}
      </Flex>
    );
  };

  return (
    <SelectAllWrapper style={hideSelectAll ? { padding: 0 } : undefined}>
      {getSelectAllRow()}
      {restoreToGlobalData.shouldDisplay && overflowRestore && (
        <div style={{ margin: "6px 0 10px 0" }}>{restoreToGlobalButton}</div>
      )}
      <ExpandCollapse expanded={isExpanded}>
        <MarginSelectors />
      </ExpandCollapse>
    </SelectAllWrapper>
  );
};

export default SelectAll;

const SelectAllWrapper = styled.div`
  padding: 8px 0 0 0;
`;
const IconsWrapper = styled.div`
  font-size: 18px;
  color: ${(p) => p.theme.colors.primaryBlue};
  padding-left: 12px;
`;
